/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  getAdditionalCashListSuccess,
  getAdditionalCashListFailure,
  GetAdditionalCashListAction,
  GetAdditionalCashListActionTypes,
} from '../actions/GetAdditionalCashList';
import getAdditionalCashListService from '../services/GetAdditionalCashList';
import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';

const GetAdditionalCashListEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(GetAdditionalCashListActionTypes.GET_ADDITIONAL_CASH_LIST)),
  mergeMap((action: GetAdditionalCashListAction) => from(
    getAdditionalCashListService(action.payload.storeAliasId),
  ).pipe(
    map((response) => getAdditionalCashListSuccess({
      additionalCashList: response.data.getAdditionalCashList.data.transactions || [],
    })),
    catchError((error: IErrorActionData) => of(
      getAdditionalCashListFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default GetAdditionalCashListEpic;
